import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { usePatientsStore, useSelectFormStore, useForm } from "../../../hooks";
import {
  SelectForm,
  TextAreaForm,
  DatePickerForm,
  LoadingData,
  ErrorMessage,
  CancelButton,
  MainButton,
} from "../../ui";
import { useFormMessages } from "../../hooks";

const initialFormData = {
  procedureId: "",
};

const initialFormValidations = {
  procedureId: [(value) => value.length > 0, "Selecciona un procedimiento"],
};

export const ModalSendQuiz = ({ isSendQuiz, setIsSendQuiz, patient }) => {
  // Datos de hooks ----------------------------------------//
  const {
    //Props
    message,
    isLoading,

    //Methods
    startGetProcedurechildren,
    startSendQuiz,
  } = usePatientsStore();

  const { procedures } = useSelectFormStore(["procedures"]);

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const [proceduresChildren, setProceduresChildren] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [formValidations, setFormValidations] = useState(
    initialFormValidations
  );

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const procedureChange = async (event) => {
    const { name, value } = event.target;

    const response = await startGetProcedurechildren(value);

    const updateFormData = {
      ...formState,
      description: "",
      [name]: value,
    };

    const updateFormValidations = {
      ...formValidations,
      description: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Escribe una descripcion",
      ],
    };

    if (value === "8c868bfb-6d09-439d-af03-043883a9b8c9") {
      updateFormData.tentativeDate = "";
    } else {
      delete updateFormData.tentativeDate;
    }

    if (Array.isArray(response)) {
      setProceduresChildren(response);
      updateFormData.procedureChildrenId = "";
      updateFormValidations.procedureChildrenId = [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un procedimiento",
      ];
    }

    setFormData(updateFormData);

    setFormValidations(updateFormValidations);
  };

  const onSendQuiz = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startSendQuiz(formState, patient.id, patient.email);
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (!isSendQuiz) {
      setFormData(initialFormData);
      setFormValidations(initialFormValidations);
      setFormSubmitted(false);
      setValidateForm(false);
      onResetForm();
    }
  }, [isSendQuiz]);

  useEffect(() => {
    if (showSuccessMessage) {
      setIsSendQuiz(false);
    }
  }, [showSuccessMessage]);

  // useEffect(() => {
  //   console.log("formState", formState);
  // }, [formState]);

  // useEffect(() => {
  //   console.log("formValidation", formValidation);
  // }, [formValidation]);

  return (
    <Modal
      show={isSendQuiz}
      onHide={() => setIsSendQuiz(false)}
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title" id="exampleModalLabel1">
          Enviar flujo
        </h5>
      </Modal.Header>
      <Modal.Body>
        {patient && (
          <div className="row g-2">
            <div className="col-md-12">
              <div className="section-title text-center mb-0 pb-2">
                <h4 className="title ">Flujo de preanestesia</h4>
                <p className="mx-auto mb-0">
                  Vas a enviar el flujo al siguiente paciente:{" "}
                  <strong>{patient.email}</strong>
                </p>
              </div>
            </div>

            <div className="col-md-12">
              <SelectForm
                label={"Procedimiento"}
                options={procedures}
                labelKey={"name"}
                validation={formValidation.procedureIdValid}
                submit={validateForm}
                name={"procedureId"}
                value={formState.procedureId}
                onInputChange={procedureChange}
              />
            </div>

            {/* Otros campos */}
            <>
              {"procedureChildrenId" in formState && (
                <div className="col-md-12">
                  <SelectForm
                    label={"Propósito"}
                    options={proceduresChildren}
                    labelKey={"name"}
                    validation={formValidation.procedureChildrenIdValid}
                    submit={validateForm}
                    name={"procedureChildrenId"}
                    value={formState.procedureChildrenId}
                    onInputChange={onInputChange}
                  />
                </div>
              )}

              {"description" in formState && (
                <div className="col-md-12">
                  <TextAreaForm
                    label={"Descripción"}
                    placeholder={"Descripción"}
                    validation={formValidation.descriptionValid}
                    submit={validateForm}
                    name={"description"}
                    value={formState.description}
                    onInputChange={onInputChange}
                  />
                </div>
              )}

              {"tentativeDate" in formState && (
                <div className="col-12">
                  <DatePickerForm
                    label={"Fecha de procedimiento (tentativa)"}
                    placeholder={"Elige una fecha tentativa"}
                    validation={formValidation.tentativeDateValid}
                    submit={validateForm}
                    name={"tentativeDate"}
                    value={formState.tentativeDate}
                    onChange={(selectedDate) =>
                      onInputChange({
                        target: {
                          name: "tentativeDate",
                          value: selectedDate.toISOString(),
                        },
                      })
                    }
                  />
                </div>
              )}
            </>

            {/* Mensajes */}
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <CancelButton
          type={"button"}
          onClick={() => setIsSendQuiz(false)}
          disabled={isLoading}
        >
          Cancelar
        </CancelButton>
        <MainButton
          type={"button"}
          onClick={() => onSendQuiz()}
          disabled={isLoading}
        >
          Enviar
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
